import apis from "../../core/apis.js";

class BackupScheduleResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.backupSchedule).get(options);
  }

  get(id) {
    return this.$resource(apis.backupSchedule + id).get();
  }

  search(search = "") {
    return this.$resource(apis.backupSchedule).get({ search });
  }

  post(item) {
    return this.$resource(apis.backupSchedule).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.backupSchedule + id + `/${name}`).save(item);
  }

  update(id, item) {
    return this.$resource(apis.backupSchedule + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  delete(id) {
    return this.$resource(apis.backupSchedule + id).delete();
  }
}

export default BackupScheduleResource;



// WEBPACK FOOTER //
// ./src/resources/backupSchedule/backupSchedule.resource.js